<form [formGroup]="formGroup" *transloco="let t">
	<prism-dialog
		id="sh-prog-profile-dialog"
		visible="true"
		confirmButton=""
		cancelButton=""
		[closeOnEsc]="isCloseOnEsc"
	>
		<span id="sh-prog-profile-dialog-title-h1" slot="dialog-title">
			{{ t('cloud.shure-cloud.home-page.progressive-profile-title') }}
		</span>
		<ng-container *ngFor="let formRow of formData">
			<div *ngIf="formRow.type === formType.Text">
				<prism-input
					id="sh-prog-profile-dialog-field-{{ formRow.name }}"
					angular-input
					[formControlName]="formRow.name"
					[placeholder]="t(formRow.label)"
					(valueInput)="onBlur(formRow.name)"
					[isValid]="!formGroup.get(formRow.name)?.invalid"
				>
					<span slot="label" id="sh-prog-profile-dialog-{{ formRow.name }}-label">
						{{ t(formRow.label) }}
					</span>
				</prism-input>
			</div>
			<div id="sh-prog-profile-error">
				@if (formGroup.get(formRow.name)?.touched && formGroup.get(formRow.name)?.errors) {
					<span class="prism-caption" id="sh-prog-profile-form-error-text">
						{{ getPhoneErrorMessage(formRow.name) }}
					</span>
				}
			</div>

			<div *ngIf="formRow.type === formType.Select">
				<prism-select
					id="sh-prog-profile-dialog-{{ formRow.name }}-select"
					angular-input
					[formControlName]="formRow.name"
					(valueChange)="formRow.name === 'segment' ? segmentSelected($event.detail) : null"
				>
					<span slot="label" id="sh-prog-profile-dialog-{{ formRow.name }}-label">
						{{ t(formRow.label) }}
					</span>

					<prism-menu>
						@for (dataValue of formRow.data; track dataValue.value) {
							<prism-menu-item [value]="dataValue.value" class="sh-prism-menu-option">
								{{ t(dataValue.label) }}
							</prism-menu-item>
						}
					</prism-menu>
				</prism-select>

				<span
					class="prism-caption sh-account-form-error"
					*ngIf="formGroup.controls[formRow.name]?.invalid && formGroup.controls[formRow.name]?.touched"
				>
					{{ t('cloud.shure-cloud.error-labels.invalid-value') }}
				</span>
			</div>
			<div *ngIf="formRow.type === formType.Checkbox" class="sh-prog-profile-dialog-checkbox-div">
				<span
					*ngIf="formRow.name !== 'tc'"
					id="sh-prog-profile-dialog-{{ formRow.name }}-mat-label"
					slot="label"
					>{{ t(formRow.label) }}</span
				>
				<ng-container *ngIf="formRow.name === 'relationToShure'">
					<div [formGroupName]="formRow.name">
						<div *ngFor="let option of relationshipOptions">
							<prism-checkbox [formControlName]="option.name">{{ t(option.label) }}</prism-checkbox>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf="formRow.name === 'interests'">
					<div [formGroupName]="formRow.name">
						<div *ngFor="let option of interestsOptions">
							<prism-checkbox [formControlName]="option.name">{{ t(option.label) }}</prism-checkbox>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf="formRow.name === 'tc'">
					<div [formGroupName]="formRow.name">
						<prism-checkbox
							[formControlName]="'isTcAccepted'"
							id="sh-prog-profile-dialog-tnc-prism-checkbox"
							>{{ t('cloud.shure-cloud.terms-and-conditions.terms-text') }}
							<a id="sh-progressive-dialog-tc-link" [href]="termsUrl" target="_blank">{{
								t('cloud.shure-cloud.terms-and-conditions.terms-link')
							}}</a></prism-checkbox
						>
					</div>
				</ng-container>
			</div>
		</ng-container>

		<div slot="dialog-footer-buttons" id="sh-prog-profile-dialog-button">
			<prism-button
				[disabled]="formGroup.invalid"
				(click)="onSubmit()"
				id="sh-prog-profile-dialog-continue-button"
			>
				{{ t('cloud.shared.button-text.continue') }}
			</prism-button>
		</div>
	</prism-dialog>
</form>
